module.exports = __webpack_public_path__ + "img/umbrella-on-ground.7d605dd.png";